"use client";

import { FC } from "react";
import Leaderboard from "components/atoms/Leaderboard";
import { Title } from "utils/styling/typography.styled";
import * as Styled from "./LeaderboardLanding.styled";
export const LeaderboardLanding: FC = () => {
  return <Styled.Container data-sentry-element="unknown" data-sentry-component="LeaderboardLanding" data-sentry-source-file="index.tsx">
            <Styled.Header data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Title data-sentry-element="Title" data-sentry-source-file="index.tsx">CharGen Leaderboards: Top Creators of the Month</Title>
            </Styled.Header>
            <Leaderboard data-sentry-element="Leaderboard" data-sentry-source-file="index.tsx" />
            <Styled.AboutSection data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Styled.AboutTitle data-sentry-element="unknown" data-sentry-source-file="index.tsx">What is the Leaderboard?</Styled.AboutTitle>
                <Styled.AboutText data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    Explore the top contributors and most voted creators in the
                    CharGen community. Check out the leaderboards to see who is
                    creating the most popular AI-generated D&D character art.
                </Styled.AboutText>
                <br></br>
                <Styled.AboutText data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    The CharGen Leaderboard showcases the top creators of the
                    month based on community votes for publicly shared images.
                    The rankings are updated every month, reflecting the votes
                    received by the images generated within the current month.
                </Styled.AboutText>
                <br></br>
                <Styled.AboutText data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    This is your chance to see who the community loves the most
                    and to get inspired by the most voted D&D character art. The
                    top voted users each month receive special recognition and
                    award gold. Keep creating and voting to see your favorite
                    artists rise to the top!
                </Styled.AboutText>
                <br />
                <Styled.AboutText data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    Only images that are publicly shared and voted on by the
                    community are eligible for the leaderboard. Make sure to
                    share your creations and encourage others to vote!
                </Styled.AboutText>
            </Styled.AboutSection>
        </Styled.Container>;
};